export class DayModel {
    public dayCode:string;
    public dayName:string;
}